import React, { Component } from 'react';
import { getFormValues, reduxForm, formValueSelector } from 'redux-form';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';

import { VENDOR_FORM_NAME } from 'Common/FormEnum';
import { VendorFieldEnum as Fields } from 'Common/FieldEnum';
import { isValidEmail } from 'Common/FormHelper';

import { VendorInfoFields } from './VendorInfoFields';


class VendorForm extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    formValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    change: PropTypes.func,
    IsPOAddSameAsRemittance: PropTypes.bool,
    POAddress1: PropTypes.string,
    POAddress2: PropTypes.string,
    POZip: PropTypes.string,
    POState: PropTypes.string,
    POCity: PropTypes.string,
    POPhone: PropTypes.string,
  };

  static defaultProps = {
    onSubmit: () => {},
    change: () => {},
    IsPOAddSameAsRemittance: false,
    POAddress1: '',
    POAddress2: '',
    POZip: '',
    POState: '',
    POCity: '',
    POPhone: '',
  };

  setSameAsPOAddress = (event, newValue) => {
    if (newValue) {
      this.updateRemitAddressValues();
    }
  };

  handleChangeOfPOAddress = (event, newValue) => {
    const { change } = this.props;
    if (this.props.IsPOAddSameAsRemittance) {
      change(Fields.IsPOAddSameAsRemittance, false);
    }
  };

  updateRemitAddressValues = () => {
    const {
      POAddress1,
      POAddress2,
      POZip,
      POState,
      POCity,
      POPhone,
      change,
    } = this.props;
    change(Fields.RemitAddress1, POAddress1);
    change(Fields.RemitAddress2, POAddress2);
    change(Fields.RemitZip, POZip);
    change(Fields.RemitState, POState);
    change(Fields.RemitCity, POCity);
    change(Fields.RemitPhone, POPhone);
  };

  render() {
    const { onSubmit, formValues, IsPOAddSameAsRemittance } = this.props;

    return (
      <Form onSubmit={onSubmit}>
        <VendorInfoFields
          formValues={formValues}
          setSameAsPOAddress={this.setSameAsPOAddress}
          IsPOAddSameAsRemittance={IsPOAddSameAsRemittance}
          handleChangeOfPOAddress={this.handleChangeOfPOAddress}
        />
      </Form>
    );
  }
}

const mapStateToProps = state => {
  const formValues = getFormValues(VENDOR_FORM_NAME)(state);
  const selector = formValueSelector(VENDOR_FORM_NAME);
  return {
    formValues,
    IsPOAddSameAsRemittance: selector(state, Fields.IsPOAddSameAsRemittance),
    POAddress1: selector(state, Fields.POAddress1),
    POAddress2: selector(state, Fields.POAddress2),
    POZip: selector(state, Fields.POZip),
    POState: selector(state, Fields.POState),
    POCity: selector(state, Fields.POCity),
    POPhone: selector(state, Fields.POPhone),
  };
};

const validate = (values, props) => {
  const errors = {};
  if (
    !values[Fields.VendorNum] ||
    _.trim(values[Fields.VendorNum]).length === 0
  ) {
    errors[Fields.VendorNum] = 'Distributor id is required.';
  }
  if (
    !values[Fields.Description] ||
    _.trim(values[Fields.Description]).length === 0
  ) {
    errors[Fields.Description] = 'Distributor name is required.';
  }
  if (
    values[Fields.POEmail] &&
    _.trim(values[Fields.POEmail]).length > 0 &&
    !isValidEmail(values[Fields.POEmail])
  ) {
    errors[Fields.POEmail] = 'Email address is invalid.';
  }
  if (values[Fields.POZip]) {
    const poZipCode = values[Fields.POZip].replace(/[^a-z0-9]+/g, '');
    if (poZipCode.length !== 5 && poZipCode.length !== 9) {
      errors[Fields.POZip] = 'Please enter a valid Zip +4 code.';
    }
  }
  if (values[Fields.RemitZip]) {
    const remitZipCode = values[Fields.RemitZip].replace(/[^a-z0-9]+/g, '');
    if (remitZipCode.length !== 5 && remitZipCode.length !== 9) {
      errors[Fields.RemitZip] = 'Please enter a valid Zip +4 code.';
    }
  }
  return errors;
};

VendorForm = connect(mapStateToProps)(VendorForm);

export default reduxForm({
  validate,
  form: VENDOR_FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true,
})(VendorForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/VendorForm.js